import MobileMenuItemWrapper from 'common/components/entities/Menu/components/Mobile/components/MobileMenuItem/ui/MobileMenuItemWrapper'
import MobileMenuWrapper from 'common/components/entities/Menu/components/Mobile/components/MobileMenuItem/ui/MobileMenuWrapper'
import MobileSubMenuChevronUi from 'common/components/entities/Menu/components/Mobile/components/MobileMenuItem/ui/MobileSubMenuChevronUi'
import MobileSubMenuWrapperUi from 'common/components/entities/Menu/components/Mobile/components/MobileMenuItem/ui/MobileSubMenuWrapper'
import MenuItemUi, {
  MenuItemUiProps,
} from 'common/components/entities/Menu/components/ui/MenuItemUi'
import useActiveMenuItem from 'common/components/entities/Menu/hooks/useActiveMenuItem'
import { MenuItemInterface } from 'common/components/entities/Menu/types/MenuInterface'
import { hasSubMenu } from 'common/components/entities/Menu/utils/hasSubMenu'
import { publisherFontAwesomeIconsEnum } from 'common/constants/fontAwesomeConst'
import { isBlogReplacementPlaceholder } from 'common/utils/blogReplacementsUtils'
import React, { useEffect, useState } from 'react'

interface MobileMenuItemProps
  extends Omit<MenuItemUiProps, 'isActive' | 'hasSubMenu'> {
  attrId: string
  item: MenuItemInterface
  index: number
  spacing?: number
  isEditing?: boolean
}

const Index = ({
  attrId,
  item,
  index,
  spacing,
  isEditing,
  ...rest
}: MobileMenuItemProps) => {
  const { target, text, subMenuItems, link } = item
  const [position, setPosition] = useState<'relative' | 'absolute'>('absolute')
  const isOpenInEditMode = (isEditing && item.subMenuOpen) || false

  const { setHoveredItemIndex, isItemActive, activeSubitems } =
    useActiveMenuItem(item, index)

  useEffect(() => {
    if (isItemActive || isOpenInEditMode) {
      setPosition('relative')
    } else {
      setTimeout(() => setPosition('absolute'), 150)
    }
  }, [isOpenInEditMode, index, isItemActive])

  return (
    <li>
      <MobileMenuWrapper>
        <MobileMenuItemWrapper
          onClick={() =>
            setHoveredItemIndex(prev => (prev === index ? null : index))
          }
        >
          <MenuItemUi
            as={hasSubMenu(item) ? 'span' : 'a'}
            isMobile
            href={link}
            target={target}
            isActive={isItemActive}
            {...rest}
          >
            {text}
          </MenuItemUi>
          {hasSubMenu(item) && (
            <MobileSubMenuChevronUi
              opened={isItemActive || isOpenInEditMode}
              color={
                isItemActive
                  ? rest.mobileActiveColor || rest.activeColor || ''
                  : rest.mobileColor || rest.color || ''
              }
              className={publisherFontAwesomeIconsEnum.ChevronDownSolid}
            />
          )}
        </MobileMenuItemWrapper>
        {hasSubMenu(item) && (
          <MobileSubMenuWrapperUi
            position={position}
            opened={isItemActive || isOpenInEditMode}
            spacing={spacing}
          >
            {subMenuItems
              ?.filter(subItem => !isBlogReplacementPlaceholder(subItem.link))
              .map((subItem, subIndex) => (
                <MenuItemUi
                  as={'a'}
                  isMobile
                  key={`${attrId}-mobile-link-subItem-${index}-${subIndex}-${
                    subItem.link || subItem.text
                  }`}
                  href={subItem.link}
                  target={subItem.target}
                  isActive={activeSubitems.includes(subIndex)}
                  {...rest}
                >
                  {subItem.text}
                </MenuItemUi>
              ))}
          </MobileSubMenuWrapperUi>
        )}
      </MobileMenuWrapper>
    </li>
  )
}

export default Index
